import { assertNever } from 'owa-assert';
import { getOwaCommonStrings } from 'owa-strings/owa-common-strings';
import { getStore } from '../store/store';
import { getUploadFolder } from 'owa-attachments-upload-folder';
import { isGroupProviderViewState, isOneDriveProViewState } from '../utils/typeGuards';
import { isStringNullOrWhiteSpace } from 'owa-strings';

export function getSelectedFolderName(): string | null {
    const { providerViewState } = getStore();

    if (isOneDriveProViewState(providerViewState)) {
        const uploadFolder = getUploadFolder();

        return uploadFolder && !isStringNullOrWhiteSpace(uploadFolder.folderName)
            ? uploadFolder.folderName
            : getOwaCommonStrings().defaultUploadLocationFolderName;
    } else if (isGroupProviderViewState(providerViewState)) {
        const uploadFolder = getUploadFolder(providerViewState.groupMailboxId);

        return uploadFolder
            ? uploadFolder.folderName
            : getOwaCommonStrings().groupDefaultUploadLocationFolderName;
    }

    return assertNever(providerViewState);
}
